import PropTypes from 'prop-types';
import { forwardRef, useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

// @mui
import { Button, Fade, Popover } from '@mui/material';
import { styled } from '@mui/material/styles';
import { getActive, useActiveLink } from '../../hooks/useActiveLink';

const Transition = forwardRef((props, ref) => <Fade direction="up" ref={ref} {...props} />);

// ==============================|| List Item Style ||============================== //
const ListItemStyle = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'activeRoot' && prop !== 'selected' && prop !== 'open',
})(({ activeRoot, selected, open, theme }) => {

  return {
    position: 'relative',
    ...theme.typography.hoverSecondaryUnderline2px,
    ...theme.typography.body1,
    minWidth: 0,
    // padding: theme.spacing(0, 1),
    margin: theme.spacing(0, 1),
    color: theme.palette.common.white,
    // open
    ...(open && {
        '&:after': {
          content: '""',
          display: 'block',
          position: 'absolute',
          bottom: 0,
          right: 0,
          left: 0,
          margin: '0 auto',
          width: '100%',
          height: '2px',
          background: theme.palette.color.secondaryGreen1,
          transition: 'all 0.5s',
        },
      }
    ),
    ...(open &&
      activeRoot && {
        // color: theme.palette.error.main,
    }),

    ...(activeRoot && {
      transition: 'all 0.5s',
      ...theme.typography.fullLine,
    }),

    ...(selected && {
      transition: 'all 0.5s',
      ...theme.typography.fullLine,
    })
  };
});

// ==============================|| Paper Style ||============================== //
const PaperStyle = styled(Popover)(({ theme }) => ({
  pointerEvents: 'none',
  '& .MuiPopover-paper': {
    maxWidth: '100%',
    left: '0px !important',
    right: '0px',
    pointerEvents: 'auto',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    backdropFilter: 'blur(10px)',
    // clip: 'rect(0px, 100vw, 200vh, -30px)',
    padding: theme.spacing(5),
    borderRadius: Number(theme.shape.borderRadius) * 0, // * 1.5
    // boxShadow: theme.customShadows.dropdown,
  },
}));


IconOverlay.propTypes = {
    list: PropTypes.shape({
      children: PropTypes.array,
      path: PropTypes.string,
    }),
};
export function IconOverlay({ primary, path, content, children, selected, anchorOrigin= { vertical: 'bottom', horizontal: 'center' }, transformOrigin = { vertical: 'top', horizontal: 'center' } }) {
    const menuRef = useRef(null);
    
    const active = useActiveLink(path, false);

    // const active = getActive(item.props?.path, pathname)
  
    const [open, setOpen] = useState(false);
  
    const handleOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };
  
    // const hasChildren = list?.children;
  
    return (
      <>
        {
          !!path ? (
            <ListItemStyle
              ref={menuRef}
              open={open}
              activeRoot={active}
              selected={selected}
              onMouseEnter={handleOpen}
              onMouseLeave={handleClose}
              component={RouterLink}
              to={path}
            >
              { primary }
            </ListItemStyle>
          ) : (
            <ListItemStyle
              ref={menuRef}
              open={open}
              activeRoot={active}
              selected={selected}
              onMouseEnter={handleOpen}
              onMouseLeave={handleClose}
            >
              { primary }
            </ListItemStyle>
          )
        }
  
        {
          (content || children) && (
            <PaperStyle
              TransitionComponent={Transition}
              disableRestoreFocus
              disableScrollLock
              open={open}
              anchorEl={menuRef.current}
              anchorOrigin={anchorOrigin}
              transformOrigin={transformOrigin}
              PaperProps={{
                onMouseEnter: handleOpen,
                onMouseLeave: handleClose,
              }}
            >
              { content || children }
            </PaperStyle>
          )
        }
      </>
    );
}
  